import { useEffect, useState } from "react";
import { FlexColumn } from "styles/layout";
import { BracketPickerMatchTeam } from "./BracketPickerMatchTeam";
import { getStringPick, Pick } from "model/Pickem/Pickem";
import { BracketPickOption } from "model/Bracket/BracketPickOptions";
import { isPlaceholderRosterId } from "model/Roster/Roster";

interface Props {
  matchId: string;
  tournamentId: string;
  picks: { [matchId: string]: Pick };
  updatePick: (matchId: string, rosterId: string | undefined) => void; //todo - better way to do this?
  pickOptions: BracketPickOption[];
}

export const BracketPickerMatch = ({
  matchId,
  tournamentId,
  picks,
  updatePick,
  pickOptions,
}: Props) => {
  const { rosterOneId, rosterTwoId } =
    pickOptions.find((o) => o.matchId === matchId) || {};
  const [selectedRosterId, setSelectedRosterId] = useState<
    string | undefined
  >();

  const updateSelectedRoster = (rosterId: string | undefined) => {
    let actualRosterId = rosterId;
    if (!!rosterId && !!rosterOneId && !!rosterTwoId) {
      if (isPlaceholderRosterId(rosterTwoId)) {
        actualRosterId = rosterOneId;
      }
      if (isPlaceholderRosterId(rosterOneId)) {
        actualRosterId = rosterTwoId;
      }
    }

    if (selectedRosterId === actualRosterId) {
      return;
    }

    setSelectedRosterId(actualRosterId);
    updatePick(matchId, actualRosterId);
  };

  useEffect(() => {
    updateSelectedRoster(getStringPick(picks, matchId));
  }, [picks]);

  const disableSelection = !rosterOneId || !rosterTwoId;

  return (
    <FlexColumn>
      <BracketPickerMatchTeam
        rosterId={rosterOneId}
        tournamentId={tournamentId}
        selectedRosterId={selectedRosterId}
        disableSelection={disableSelection}
        updateSelectedRoster={updateSelectedRoster}
      />
      <BracketPickerMatchTeam
        rosterId={rosterTwoId}
        tournamentId={tournamentId}
        selectedRosterId={selectedRosterId}
        disableSelection={disableSelection}
        updateSelectedRoster={updateSelectedRoster}
      />
    </FlexColumn>
  );
};
